import type { PropsWithChildren } from "react";

import {
  ArrowsInIcon,
  Button,
  Divider,
  Heading,
  QuestionIcon,
} from "@stacklet/ui";

import { useToggleSearchParam } from "app/hooks/routing/useToggleSearchParam";

/**
 * Contextual help card shown beside the page content while `?help=true` is
 * set; the page layout supplies the content as children.
 */
export function HelpDrawer({ children }: PropsWithChildren) {
  const [, toggleHelp] = useToggleSearchParam("help");

  return (
    <aside
      aria-label="Help"
      // Sticks below the sticky breadcrumb header; the body scrolls on its own.
      className="sticky top-20 flex max-h-[calc(100vh-6rem)] w-[350px] max-w-[33%] shrink-0 flex-col gap-y-xl rounded-sm border-2 border-background-secondary bg-background-primary py-xl"
    >
      <div className="flex items-center justify-between px-xl">
        <div className="flex items-center gap-x-sm text-text-primary">
          <QuestionIcon size={24} />
          <Heading level={2}>Help</Heading>
        </div>
        <Button aria-label="Close help" onPress={toggleHelp} variant="tertiary">
          <ArrowsInIcon size={16} />
        </Button>
      </div>
      <Divider className="border-background-secondary" />
      {/* Focusable so keyboard users can scroll long help copy. */}
      <div
        className="flex min-h-0 flex-col gap-y-xl overflow-y-auto px-2xl text-body-medium text-text-primary"
        tabIndex={0}
      >
        {children}
      </div>
    </aside>
  );
}
